(()=>{
 'use strict';
 if(window.CeikaProductHero)return;
 const instances=new Map();
 function scan(scope=document){
  scope.querySelectorAll('.ceika-product-pilot').forEach(page=>{
   if(instances.has(page))return;
   const display=page.querySelector('[data-ceika-hero-price]'),target=page.querySelector('[data-ceika-hero-total]');
   if(!display||!target)return;
   const sync=()=>{
    const source=page.querySelector('[data-pilot-grand-total]');
    const value=source?.textContent.trim()||'';
    const controller=source?.closest('.ceika-native-pilot');
    const ready=controller?.dataset.priceLoadState==='ready'&&controller.dataset.extrasPriceState==='ready'&&controller.dataset.nativeError!=='true'&&controller.dataset.hardwareBlocked!=='true';
    const visible=Boolean(ready&&source&&!source.closest('[hidden]')&&/\d/.test(value));
    const next=visible?value:'';
    if(target.textContent!==next)target.textContent=next;
    if(display.hidden===visible)display.hidden=!visible;
   };
   const observer=new MutationObserver(sync);observer.observe(page,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['hidden','data-price-load-state','data-extras-price-state','data-native-error','data-hardware-blocked']});
   instances.set(page,observer);sync();
  });
 }
 window.CeikaProductHero={scan};
 document.addEventListener('DOMContentLoaded',()=>scan());
 document.addEventListener('shopify:section:load',event=>scan(event.target));
 document.addEventListener('shopify:section:unload',event=>{for(const[page,observer]of instances)if(event.target.contains(page)){observer.disconnect();instances.delete(page);}});
 if(document.readyState!=='loading')scan();
})();
